// extracted by mini-css-extract-plugin
module.exports = {"root":"Images90_root__1zKpN","title":"Images90_title__24ONL","images":"Images90_images__3ytvx"};